import { Box } from "@mui/system";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";
import { useSelector } from "react-redux";
import RSOverTimeChartWrap from "./RSContent/RSOverTime/RSOverTimeChartWrap";
import RSPVChartWrap from "./RSContent/RSPV/RSPVChartWrap";
import AverageRSPercDealChartWrap from "./RSContent/AverageRSPercDeal/AverageRSPercDealChartWrap";

const RS = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <>
            <RSOverTimeChartWrap />
            <RSPVChartWrap />
            <AverageRSPercDealChartWrap />
          </>
        )}
      </Box>
    </>
  );
};
export default RS;
